import {Directive} from '@angular/core';
import {NG_ASYNC_VALIDATORS, UntypedFormControl, Validator} from '@angular/forms';
import {DataService} from 'src/app/services';
import {Observable} from 'rxjs';


@Directive({    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[cmnDeviceName][formControlName], [cmnDeviceName][formControl], [cmnDeviceName][ngModel]',
    providers: [{provide: NG_ASYNC_VALIDATORS, useExisting: CmnDeviceNameDirective, multi: true}]
    // providers: [{provide: NG_VALIDATORS, useExisting: CmnDeviceNameDirective, multi: true}]
})
export class CmnDeviceNameDirective implements Validator {
    isDeviceNameValid = false;
    searchString: string;

    constructor(public dataService: DataService) {
    }
    validateAsync(c: UntypedFormControl): Observable<{ [key: string]: any }> {
        return new Observable(obs => {
            if (this.searchString !== c.value) {
                this.searchString = c.value;
                if (c.value) {
                    this.isValid(c.value).subscribe(res => {
                        this.isDeviceNameValid = res;
                        obs.next(this.isDeviceNameValid ? null : {invalid: true});
                        obs.complete();
                    });
                } else {
                    obs.next({invalid: true});
                    obs.complete();
                }
            } else {
                obs.next(this.isDeviceNameValid ? null : {invalid: true});
                obs.complete();
            }
        });
    }

    validate(c: UntypedFormControl): Observable<{ [key: string]: any }> {
        return this.validateAsync(c);
    }

    isValid(input?: string): Observable<boolean> {
        return this.dataService.getDeviceNameAvailability(input);
    }
}
